// Platform Events Configuration
export const PLATFORM_EVENTS = {
  // Authentication Events
  VIEW_AUTH_SCREEN: {
    name: 'view_auth_screen',
    description: 'User sees the initial auth screen with phone/Google options',
    trigger: 'On screen load',
    category: 'Screen View',
    feature: 'Authentication',
    properties: ['available_methods'],
    importance: 'High',
    owner: 'Frontend Team'
  },
  SUBMIT_PHONE_NUMBER: {
    name: 'submit_phone_number',
    description: 'User submits their phone number',
    trigger: 'On continue button',
    category: 'Form Submit',
    feature: 'Phone Auth',
    properties: ['phone_number', 'input_method'],
    importance: 'High',
    owner: 'Frontend Team'
  },
  VIEW_OTP_SCREEN: {
    name: 'view_otp_screen',
    description: 'OTP input screen is displayed',
    trigger: 'On screen load',
    category: 'Screen View',
    feature: 'Phone Auth',
    properties: [],
    importance: 'High',
    owner: 'Frontend Team'
  },
  SUBMIT_OTP_CODE: {
    name: 'submit_otp_code',
    description: 'User submits OTP code',
    trigger: 'On OTP submit',
    category: 'Form Submit',
    feature: 'Phone Auth',
    properties: ['otp_length', 'attempts'],
    importance: 'High',
    owner: 'Frontend Team'
  },
  OTP_VERIFICATION_SUCCESS: {
    name: 'otp_verification_success',
    description: 'OTP is verified successfully via Firebase',
    trigger: 'On Firebase success callback',
    category: 'Tech Event',
    feature: 'Phone Auth',
    properties: ['method', 'user_id'],
    importance: 'Critical',
    owner: 'Backend Team'
  },
  OTP_VERIFICATION_FAILED: {
    name: 'otp_verification_failed',
    description: 'OTP verification failed via Firebase',
    trigger: 'On Firebase error callback',
    category: 'Tech Event',
    feature: 'Phone Auth',
    properties: ['method', 'error_code'],
    importance: 'High',
    owner: 'Backend Team'
  },
  CLICK_CONTINUE_GOOGLE: {
    name: 'click_continue_google',
    description: 'User selects Google as method',
    trigger: 'On button click',
    category: 'Click',
    feature: 'Authentication',
    properties: [],
    importance: 'Medium',
    owner: 'Frontend Team'
  },
  GOOGLE_REDIRECT_STARTED: {
    name: 'google_redirect_started',
    description: 'User is redirected to Google account picker',
    trigger: 'On redirect',
    category: 'Navigation',
    feature: 'Google Auth',
    properties: [],
    importance: 'Medium',
    owner: 'Frontend Team'
  },
  GOOGLE_AUTH_SUCCESS: {
    name: 'google_auth_success',
    description: 'Google authentication successful via Firebase',
    trigger: 'On Firebase success callback',
    category: 'Tech Event',
    feature: 'Google Auth',
    properties: ['method', 'user_id'],
    importance: 'Critical',
    owner: 'Backend Team'
  },
  GOOGLE_AUTH_FAILED: {
    name: 'google_auth_failed',
    description: 'Google authentication failed',
    trigger: 'On Firebase error callback',
    category: 'Tech Event',
    feature: 'Google Auth',
    properties: ['method', 'error_code'],
    importance: 'High',
    owner: 'Backend Team'
  },
  USER_IDENTIFICATION_RESULT: {
    name: 'user_identification_result',
    description: 'System checks if user exists in DB after auth',
    trigger: 'On backend response',
    category: 'Tech Event',
    feature: 'Authentication',
    properties: ['is_existing_user', 'user_id'],
    importance: 'High',
    owner: 'Backend Team'
  },

  // Feedback Events
  VIEW_FEEDBACK_MODAL: {
    name: 'view_feedback_modal',
    description: 'Feedback modal is displayed to the user',
    trigger: 'On feedback modal open',
    category: 'Screen View',
    feature: 'Feedback',
    properties: ['entry_point', 'report_id', 'card_id', 'feedback_context', 'variant'],
    importance: 'High',
    owner: 'Frontend Team'
  },
  CLICK_FEEDBACK_SKIP: {
    name: 'click_feedback_skip',
    description: 'User clicks Skip & Continue on feedback modal',
    trigger: 'On skip click',
    category: 'Click',
    feature: 'Feedback',
    properties: ['entry_point', 'report_id', 'card_id', 'feedback_context', 'variant'],
    importance: 'Medium',
    owner: 'Frontend Team'
  },
  VIEW_FEEDBACK_THANK_YOU: {
    name: 'view_feedback_thank_you',
    description: 'Thank you screen is shown after submitting feedback',
    trigger: 'On thank you screen appear',
    category: 'Screen View',
    feature: 'Feedback',
    properties: ['entry_point', 'report_id', 'card_id', 'feedback_type', 'feedback_value', 'feedback_context', 'variant'],
    importance: 'High',
    owner: 'Frontend Team'
  },
  CLICK_FEEDBACK_THANK_YOU_CONTINUE: {
    name: 'click_feedback_thank_you_continue',
    description: 'User clicks Continue on thank you screen',
    trigger: 'On continue click',
    category: 'Click',
    feature: 'Feedback',
    properties: ['entry_point', 'report_id', 'card_id', 'destination', 'feedback_context', 'variant'],
    importance: 'Medium',
    owner: 'Frontend Team'
  },

  // Profile Setup Events
  VIEW_NAME_INPUT_SCREEN: {
    name: 'view_name_input_screen',
    description: 'Name input screen shown (new users only)',
    trigger: 'On screen load (if new user)',
    category: 'Screen View',
    feature: 'Profile Setup',
    properties: ['flow'],
    importance: 'Medium',
    owner: 'Frontend Team'
  },
  SUBMIT_USER_NAME: {
    name: 'submit_user_name',
    description: 'User submits their name',
    trigger: 'On continue button',
    category: 'Form Submit',
    feature: 'Profile Setup',
    properties: ['name_length', 'input_method'],
    importance: 'Medium',
    owner: 'Frontend Team'
  },

  // Onboarding Events
  VIEW_WELCOME_SCREEN: {
    name: 'view_welcome_screen',
    description: 'Welcome screen is shown',
    trigger: 'On screen load (if new user)',
    category: 'Screen View',
    feature: 'Onboarding',
    properties: [],
    importance: 'Medium',
    owner: 'Frontend Team'
  },
  CLICK_NEXT_WELCOME: {
    name: 'click_next_welcome',
    description: 'User clicks "Next" on welcome screen',
    trigger: 'On button click',
    category: 'Click',
    feature: 'Onboarding',
    properties: [],
    importance: 'Medium',
    owner: 'Frontend Team'
  },
  VIEW_TUTORIAL_CRY_ANALYSER: {
    name: 'view_tutorial_cry_analyser',
    description: 'First tutorial screen (Cry Analyser) shown',
    trigger: 'On screen load',
    category: 'Screen View',
    feature: 'Onboarding Tutorial',
    properties: ['tutorial_step'],
    importance: 'Medium',
    owner: 'Frontend Team'
  },
  CLICK_NEXT_TUTORIAL_1: {
    name: 'click_next_tutorial_1',
    description: 'User clicks "Next" on Cry Analyser screen',
    trigger: 'On button click',
    category: 'Click',
    feature: 'Onboarding Tutorial',
    properties: [],
    importance: 'Medium',
    owner: 'Frontend Team'
  },
  VIEW_TUTORIAL_MEET_QARA: {
    name: 'view_tutorial_meet_qara',
    description: 'Second tutorial screen (Meet Qara) shown',
    trigger: 'On screen load',
    category: 'Screen View',
    feature: 'Onboarding Tutorial',
    properties: ['tutorial_step'],
    importance: 'Medium',
    owner: 'Frontend Team'
  },
  CLICK_NEXT_TUTORIAL_2: {
    name: 'click_next_tutorial_2',
    description: 'User clicks "Next" on Meet Qara screen',
    trigger: 'On button click',
    category: 'Click',
    feature: 'Onboarding Tutorial',
    properties: [],
    importance: 'Medium',
    owner: 'Frontend Team'
  },
  VIEW_TUTORIAL_EXPERT_CARE: {
    name: 'view_tutorial_expert_care',
    description: 'Third tutorial screen (Expert Care) shown',
    trigger: 'On screen load',
    category: 'Screen View',
    feature: 'Onboarding Tutorial',
    properties: ['tutorial_step'],
    importance: 'Medium',
    owner: 'Frontend Team'
  },
  CLICK_GET_STARTED: {
    name: 'click_get_started',
    description: 'User clicks "Get Started" to complete onboarding',
    trigger: 'On button click',
    category: 'Click',
    feature: 'Onboarding Tutorial',
    properties: [],
    importance: 'High',
    owner: 'Frontend Team'
  },
  LOGOUT_CLICKED: {
    name: 'logout_clicked',
    description: 'User clicks logout button/profile option',
    trigger: 'On logout button click',
    category: 'Click',
    feature: 'Authentication',
    properties: ['entry_point'],
    importance: 'High',
    owner: 'Frontend Team'
  },
  LOGOUT_SUCCESS: {
    name: 'logout_success',
    description: 'User successfully logged out',
    trigger: 'On Firebase signOut success',
    category: 'Tech Event',
    feature: 'Authentication',
    properties: ['method', 'user_id'],
    importance: 'High',
    owner: 'Frontend Team'
  },
  LOGOUT_FAILED: {
    name: 'logout_failed',
    description: 'Logout attempt failed',
    trigger: 'On Firebase signOut error',
    category: 'Tech Event',
    feature: 'Authentication',
    properties: ['method', 'error_code', 'error_message'],
    importance: 'High',
    owner: 'Frontend Team'
  },

  // Home Screen Events
  VIEW_HOME_SCREEN: {
    name: 'view_home_screen',
    description: 'User lands on the main home screen',
    trigger: 'On screen load',
    category: 'Screen View',
    feature: 'Home',
    properties: ['entry_point', 'is_new_user'],
    importance: 'High',
    owner: 'Frontend Team'
  },
  ENTRY_CRY_ANALYSER_CARD: {
    name: 'entry_cry_analyser_card',
    description: 'User navigates to Cry Analyser via homepage card',
    trigger: 'On card click',
    category: 'Click',
    feature: 'Cry Analyser',
    properties: ['entry_point'],
    importance: 'Medium',
    owner: 'Frontend Team'
  },
  ENTRY_CRY_ANALYSER_NAV: {
    name: 'entry_cry_analyser_nav',
    description: 'User navigates to Cry Analyser via navigation bar',
    trigger: 'On nav button click',
    category: 'Click',
    feature: 'Cry Analyser',
    properties: ['entry_point'],
    importance: 'Medium',
    owner: 'Frontend Team'
  },
  ENTRY_QARA_CARD: {
    name: 'entry_qara_card',
    description: 'User navigates to QARA via homepage card',
    trigger: 'On card click',
    category: 'Click',
    feature: 'QARA',
    properties: ['entry_point'],
    importance: 'Medium',
    owner: 'Frontend Team'
  },
  ENTRY_QARA_NAV: {
    name: 'entry_qara_nav',
    description: 'User navigates to QARA via navigation bar',
    trigger: 'On nav button click',
    category: 'Click',
    feature: 'QARA',
    properties: ['entry_point'],
    importance: 'Medium',
    owner: 'Frontend Team'
  },
  ENTRY_EXPERTS_NAV: {
    name: 'entry_experts_nav',
    description: 'User navigates to Experts via navigation bar',
    trigger: 'On nav button click',
    category: 'Click',
    feature: 'Experts',
    properties: ['entry_point'],
    importance: 'Medium',
    owner: 'Frontend Team'
  },
  ENTRY_FOR_YOU_NAV: {
    name: 'entry_for_you_nav',
    description: 'User navigates to For You via navigation bar',
    trigger: 'On nav button click',
    category: 'Click',
    feature: 'For You',
    properties: ['entry_point'],
    importance: 'Medium',
    owner: 'Frontend Team'
  },

  // QARA Events
  VIEW_QARA_CHAT_SCREEN: {
    name: 'view_qara_chat_screen',
    description: 'User sees the Qara chat interface',
    trigger: 'On screen load',
    category: 'Screen View',
    feature: 'Qara',
    properties: ['entry_point'],
    importance: 'High',
    owner: 'Frontend Team'
  },
  START_QARA_CHAT: {
    name: 'start_qara_chat',
    description: 'User sends the first message to Qara',
    trigger: 'On message send',
    category: 'Feature Event',
    feature: 'Qara Chat',
    properties: ['message_length', 'input_type'],
    importance: 'High',
    owner: 'Frontend Team'
  },
  SEND_QARA_MESSAGE: {
    name: 'send_qara_message',
    description: 'User sends a message to QARA AI',
    trigger: 'On message send',
    category: 'Feature Event',
    feature: 'QARA',
    properties: ['message_length', 'message_type'],
    importance: 'High',
    owner: 'Frontend Team'
  },
  RECEIVE_QARA_RESPONSE: {
    name: 'receive_qara_response',
    description: 'QARA AI responds to user message',
    trigger: 'On AI response',
    category: 'Feature Event',
    feature: 'QARA',
    properties: ['response_length', 'response_type', 'response_time_ms'],
    importance: 'Medium',
    owner: 'Backend Team'
  },
  QARA_TO_EXPERT: {
    name: 'qara_to_expert',
    description: 'User navigates from Qara to Expert page',
    trigger: 'On CTA click',
    category: 'Navigation',
    feature: 'QARA',
    properties: ['destination'],
    importance: 'High',
    owner: 'Frontend Team'
  },
  QARA_TO_FORYOU: {
    name: 'qara_to_foryou',
    description: 'User navigates from Qara to For You page',
    trigger: 'On CTA click',
    category: 'Navigation',
    feature: 'QARA',
    properties: ['destination'],
    importance: 'High',
    owner: 'Frontend Team'
  },

  // Navigation Events
  HOME_TO_QARA: {
    name: 'home_to_qara',
    description: 'User navigates from Home to QARA page',
    trigger: 'On navigation',
    category: 'Navigation',
    feature: 'Global',
    properties: ['entry_point'],
    importance: 'Medium',
    owner: 'Frontend Team'
  },
  QARA_CARD_VIA_HOME: {
    name: 'qara_card_via_home',
    description: 'User clicks QARA card directly on homepage',
    trigger: 'On card click',
    category: 'Click',
    feature: 'Homepage',
    properties: ['entry_point', 'card_type'],
    importance: 'High',
    owner: 'Frontend Team'
  },
  HOME_TO_FORYOU: {
    name: 'home_to_foryou',
    description: 'User navigates from Home to For You page',
    trigger: 'On navigation',
    category: 'Navigation',
    feature: 'Global',
    properties: ['entry_point'],
    importance: 'Medium',
    owner: 'Frontend Team'
  },
  HOME_TO_EXPERTS: {
    name: 'home_to_experts',
    description: 'User navigates from Home to Experts page',
    trigger: 'On navigation',
    category: 'Navigation',
    feature: 'Global',
    properties: ['entry_point'],
    importance: 'Medium',
    owner: 'Frontend Team'
  },
  HOME_TO_CRY_ANALYSER: {
    name: 'home_to_cry_analyser',
    description: 'User navigates from Home to Cry Analyser page',
    trigger: 'On navigation',
    category: 'Navigation',
    feature: 'Global',
    properties: ['entry_point'],
    importance: 'Medium',
    owner: 'Frontend Team'
  },
  CRY_ANALYSER_CARD_VIA_HOME: {
    name: 'cry_analyser_card_via_home',
    description: 'User clicks Cry Analyser card directly on homepage',
    trigger: 'On card click',
    category: 'Click',
    feature: 'Homepage',
    properties: ['entry_point', 'card_type'],
    importance: 'High',
    owner: 'Frontend Team'
  },
  QARA_TO_HOME: {
    name: 'qara_to_home',
    description: 'User navigates from QARA to Home page',
    trigger: 'On navigation',
    category: 'Navigation',
    feature: 'Global',
    properties: ['entry_point'],
    importance: 'Medium',
    owner: 'Frontend Team'
  },
  QARA_TO_FORYOU: {
    name: 'qara_to_foryou',
    description: 'User navigates from QARA to For You page',
    trigger: 'On navigation',
    category: 'Navigation',
    feature: 'Global',
    properties: ['entry_point'],
    importance: 'Medium',
    owner: 'Frontend Team'
  },
  QARA_TO_EXPERTS: {
    name: 'qara_to_experts',
    description: 'User navigates from QARA to Experts page',
    trigger: 'On navigation',
    category: 'Navigation',
    feature: 'Global',
    properties: ['entry_point'],
    importance: 'Medium',
    owner: 'Frontend Team'
  },
  QARA_TO_CRY_ANALYSER: {
    name: 'qara_to_cry_analyser',
    description: 'User navigates from QARA to Cry Analyser page',
    trigger: 'On navigation',
    category: 'Navigation',
    feature: 'Global',
    properties: ['entry_point'],
    importance: 'Medium',
    owner: 'Frontend Team'
  },
  FORYOU_TO_HOME: {
    name: 'foryou_to_home',
    description: 'User navigates from For You to Home page',
    trigger: 'On navigation',
    category: 'Navigation',
    feature: 'Global',
    properties: ['entry_point'],
    importance: 'Medium',
    owner: 'Frontend Team'
  },
  FORYOU_TO_QARA: {
    name: 'foryou_to_qara',
    description: 'User navigates from For You to QARA page',
    trigger: 'On navigation',
    category: 'Navigation',
    feature: 'Global',
    properties: ['entry_point'],
    importance: 'Medium',
    owner: 'Frontend Team'
  },
  FORYOU_TO_EXPERTS: {
    name: 'foryou_to_experts',
    description: 'User navigates from For You to Experts page',
    trigger: 'On navigation',
    category: 'Navigation',
    feature: 'Global',
    properties: ['entry_point'],
    importance: 'Medium',
    owner: 'Frontend Team'
  },
  FORYOU_TO_CRY_ANALYSER: {
    name: 'foryou_to_cry_analyser',
    description: 'User navigates from For You to Cry Analyser page',
    trigger: 'On navigation',
    category: 'Navigation',
    feature: 'Global',
    properties: ['entry_point'],
    importance: 'Medium',
    owner: 'Frontend Team'
  },
  EXPERTS_TO_HOME: {
    name: 'experts_to_home',
    description: 'User navigates from Experts to Home page',
    trigger: 'On navigation',
    category: 'Navigation',
    feature: 'Global',
    properties: ['entry_point'],
    importance: 'Medium',
    owner: 'Frontend Team'
  },
  EXPERTS_TO_QARA: {
    name: 'experts_to_qara',
    description: 'User navigates from Experts to QARA page',
    trigger: 'On navigation',
    category: 'Navigation',
    feature: 'Global',
    properties: ['entry_point'],
    importance: 'Medium',
    owner: 'Frontend Team'
  },
  EXPERTS_TO_FORYOU: {
    name: 'experts_to_foryou',
    description: 'User navigates from Experts to For You page',
    trigger: 'On navigation',
    category: 'Navigation',
    feature: 'Global',
    properties: ['entry_point'],
    importance: 'Medium',
    owner: 'Frontend Team'
  },
  EXPERTS_TO_CRY_ANALYSER: {
    name: 'experts_to_cry_analyser',
    description: 'User navigates from Experts to Cry Analyser page',
    trigger: 'On navigation',
    category: 'Navigation',
    feature: 'Global',
    properties: ['entry_point'],
    importance: 'Medium',
    owner: 'Frontend Team'
  },
  CRY_ANALYSER_TO_HOME: {
    name: 'cry_analyser_to_home',
    description: 'User navigates from Cry Analyser to Home page',
    trigger: 'On navigation',
    category: 'Navigation',
    feature: 'Global',
    properties: ['entry_point'],
    importance: 'Medium',
    owner: 'Frontend Team'
  },
  CRY_ANALYSER_TO_QARA: {
    name: 'cry_analyser_to_qara',
    description: 'User navigates from Cry Analyser to QARA page',
    trigger: 'On navigation',
    category: 'Navigation',
    feature: 'Global',
    properties: ['entry_point'],
    importance: 'Medium',
    owner: 'Frontend Team'
  },
  CRY_ANALYSER_TO_FORYOU: {
    name: 'cry_analyser_to_foryou',
    description: 'User navigates from Cry Analyser to For You page',
    trigger: 'On navigation',
    category: 'Navigation',
    feature: 'Global',
    properties: ['entry_point'],
    importance: 'Medium',
    owner: 'Frontend Team'
  },
  CRY_ANALYSER_TO_EXPERTS: {
    name: 'cry_analyser_to_experts',
    description: 'User navigates from Cry Analyser to Experts page',
    trigger: 'On navigation',
    category: 'Navigation',
    feature: 'Global',
    properties: ['entry_point'],
    importance: 'Medium',
    owner: 'Frontend Team'
  },

  // Experts Events
  VIEW_EXPERTS_SCREEN: {
    name: 'view_experts_screen',
    description: 'Experts listing screen is displayed',
    trigger: 'On screen load',
    category: 'Screen View',
    feature: 'Experts',
    properties: ['entry_point'],
    importance: 'High',
    owner: 'Frontend Team'
  },
  FILTER_EXPERTS: {
    name: 'filter_experts',
    description: 'User applies filter/sort on experts list',
    trigger: 'On filter/sort submit',
    category: 'Interaction',
    feature: 'Experts',
    properties: ['filter_type', 'filter_value', 'sort_by'],
    importance: 'Medium',
    owner: 'Frontend Team'
  },
  VIEW_EXPERT_DETAIL: {
    name: 'view_expert_detail',
    description: 'User views expert detail page',
    trigger: 'On expert detail view',
    category: 'Screen View',
    feature: 'Experts',
    properties: ['expert_id', 'expert_specialization'],
    importance: 'Medium',
    owner: 'Frontend Team'
  },
  BACK_FROM_EXPERT_PROFILE: {
    name: 'back_from_expert_profile',
    description: 'User navigates back from expert profile',
    trigger: 'On back',
    category: 'Navigation',
    feature: 'Expert Profile',
    properties: ['expert_id'],
    importance: 'Medium',
    owner: 'Frontend Team'
  },
  CLICK_HAVE_QUERY: {
    name: 'click_have_query',
    description: 'User clicks Have query on expert profile',
    trigger: 'On CTA click',
    category: 'Interaction',
    feature: 'Expert Profile',
    properties: ['expert_id'],
    importance: 'High',
    owner: 'Frontend Team'
  },
  VIEW_CONSULTATION_POPUP: {
    name: 'view_consultation_popup',
    description: 'Consultation booking popup shown',
    trigger: 'After Have query click',
    category: 'UI',
    feature: 'Booking',
    properties: ['expert_id'],
    importance: 'High',
    owner: 'Frontend Team'
  },
  UPDATE_EMAIL: {
    name: 'update_email',
    description: 'User adds/updates email in booking popup',
    trigger: 'On input change',
    category: 'Form',
    feature: 'Booking',
    properties: ['expert_id', 'email_masked'],
    importance: 'Medium',
    owner: 'Frontend Team'
  },
  SELECT_CONSULTATION_DATE: {
    name: 'select_consultation_date',
    description: 'User selects consultation date',
    trigger: 'On date select',
    category: 'Form',
    feature: 'Booking',
    properties: ['expert_id', 'date'],
    importance: 'Medium',
    owner: 'Frontend Team'
  },
  SELECT_CONSULTATION_TIME: {
    name: 'select_consultation_time',
    description: 'User selects consultation time',
    trigger: 'On time select',
    category: 'Form',
    feature: 'Booking',
    properties: ['expert_id', 'time'],
    importance: 'Medium',
    owner: 'Frontend Team'
  },
  CONFIRM_CONSULTATION: {
    name: 'confirm_consultation',
    description: 'User confirms scheduling consultation',
    trigger: 'On Schedule Consultation click',
    category: 'Conversion',
    feature: 'Booking',
    properties: ['expert_id', 'date', 'time'],
    importance: 'High',
    owner: 'Frontend Team'
  },
  CONSULTATION_CONFIRMED: {
    name: 'consultation_confirmed',
    description: 'User sees slot reserved message (pre_consultation may be true/false)',
    trigger: 'After booking',
    category: 'System Event',
    feature: 'Booking',
    properties: ['expert_id', 'date', 'time', 'pre_consultation'],
    importance: 'High',
    owner: 'Frontend Team'
  },
  START_PRE_CONSULTATION: {
    name: 'start_pre_consultation',
    description: 'User clicks Start now to begin pre-consultation (non-Qara entries)',
    trigger: 'On Start Now click',
    category: 'Interaction',
    feature: 'Pre-Consultation',
    properties: ['expert_id'],
    importance: 'High',
    owner: 'Frontend Team'
  },
  REDIRECT_TO_QARA_PRE_CONSULT: {
    name: 'redirect_to_qara_pre_consult',
    description: 'User redirected to Qara pre-consultation flow (non-Qara entries)',
    trigger: 'After Start Now click',
    category: 'Navigation',
    feature: 'Pre-Consultation',
    properties: ['expert_id'],
    importance: 'High',
    owner: 'Frontend Team'
  },
  BACK_FROM_PRE_CONSULTATION: {
    name: 'back_from_pre_consultation',
    description: 'User goes back from pre-consultation',
    trigger: 'On back',
    category: 'Navigation',
    feature: 'Pre-Consultation',
    properties: ['expert_id'],
    importance: 'Medium',
    owner: 'Frontend Team'
  },
  BOOKING_FAILED: {
    name: 'booking_failed',
    description: 'Booking or payment failed',
    trigger: 'On error during booking',
    category: 'Tech Event',
    feature: 'Booking',
    properties: ['error_code', 'error_message', 'booking_payload'],
    importance: 'High',
    owner: 'Frontend Team'
  },
  BOOK_EXPERT_SESSION: {
    name: 'book_expert_session',
    description: 'User books a session with an expert',
    trigger: 'On booking confirmation',
    category: 'Feature Event',
    feature: 'Experts',
    properties: ['expert_id', 'session_type', 'session_duration'],
    importance: 'High',
    owner: 'Frontend Team'
  },

  // For You Events
  VIEW_FOR_YOU_SCREEN: {
    name: 'view_for_you_screen',
    description: 'For You content screen is displayed',
    trigger: 'On screen load',
    category: 'Screen View',
    feature: 'For You',
    properties: ['entry_point'],
    importance: 'High',
    owner: 'Frontend Team'
  },
  INVITE_LINK_GENERATED: {
    name: 'invite_link_generated',
    description: 'System generates a referral/invite link or deep link for the user',
    trigger: 'On invite action (server-side)',
    category: 'Tech Event',
    feature: 'Referral',
    properties: ['invite_code', 'referrer_user_id', 'channel', 'expires_at'],
    importance: 'High',
    owner: 'Backend Team'
  },
  INVITE_SENT: {
    name: 'invite_sent',
    description: 'User sends the invite via native share methods',
    trigger: 'On share/send click',
    category: 'Click/Tech',
    feature: 'Referral',
    properties: ['invite_code', 'referrer_user_id', 'method', 'recipient_masked'],
    importance: 'High',
    owner: 'Frontend Team'
  },
  INVITE_SHARE_FAILED: {
    name: 'invite_share_failed',
    description: 'Invite/share attempt failed',
    trigger: 'On client/server error',
    category: 'Tech Event',
    feature: 'Referral',
    properties: ['invite_code', 'error_code', 'error_message'],
    importance: 'Medium',
    owner: 'Frontend Team'
  },
  INVITE_LINK_CLICKED: {
    name: 'invite_link_clicked',
    description: 'Recipient clicks the invite link',
    trigger: 'On link click (deep link)',
    category: 'Tech Event',
    feature: 'Referral',
    properties: ['invite_code', 'click_ts', 'utm_params'],
    importance: 'High',
    owner: 'Backend Team'
  },
  INVITE_INSTALL_ATTRIBUTED: {
    name: 'invite_install_attributed',
    description: 'Install/signup attributed to the invite',
    trigger: 'On backend attribution',
    category: 'Tech Event',
    feature: 'Referral',
    properties: ['invite_code', 'new_user_id', 'install_ts', 'attribution_method'],
    importance: 'High',
    owner: 'Backend Team'
  },
  INVITE_CONVERSION_FAILED: {
    name: 'invite_conversion_failed',
    description: 'Attribution failed for invite install',
    trigger: 'On attribution error',
    category: 'Tech Event',
    feature: 'Referral',
    properties: ['invite_code', 'error_code'],
    importance: 'Medium',
    owner: 'Backend Team'
  },
  JOIN_COMMUNITY_REDIRECT: {
    name: 'join_community_redirect',
    description: 'User is redirected to WhatsApp to join community',
    trigger: 'On Join Community action',
    category: 'Navigation',
    feature: 'Community',
    properties: ['channel', 'community_id'],
    importance: 'Medium',
    owner: 'Frontend Team'
  },
  JOIN_COMMUNITY_SUCCESS: {
    name: 'join_community_success',
    description: 'User successfully joins community (if tracked)',
    trigger: 'On server confirmation or landing page',
    category: 'Tech Event',
    feature: 'Community',
    properties: ['community_id', 'user_id'],
    importance: 'Medium',
    owner: 'Backend Team'
  },
  JOIN_COMMUNITY_FAILED: {
    name: 'join_community_failed',
    description: 'Joining community failed',
    trigger: 'On error',
    category: 'Tech Event',
    feature: 'Community',
    properties: ['community_id', 'error_code'],
    importance: 'Medium',
    owner: 'Frontend Team'
  },
  ENTRY_FORYOU_CARD: {
    name: 'entry_foryou_card',
    description: 'User opens For You via Home card',
    trigger: 'On home card click',
    category: 'Click',
    feature: 'For You',
    properties: ['entry_point', 'card_id'],
    importance: 'High',
    owner: 'Frontend Team'
  },
  VIEW_FORYOU_FEED: {
    name: 'view_foryou_feed',
    description: 'For You feed is displayed',
    trigger: 'On screen load',
    category: 'Screen View',
    feature: 'For You',
    properties: ['feed_type', 'count_items'],
    importance: 'High',
    owner: 'Frontend Team'
  },

  // Assessment Events
  VIEW_ASSESSMENT_SCREEN: {
    name: 'view_assessment_screen',
    description: 'Assessment screen is displayed',
    trigger: 'On screen load',
    category: 'Screen View',
    feature: 'Assessment',
    properties: ['entry_point'],
    importance: 'High',
    owner: 'Frontend Team'
  },

  // Profile Events
  VIEW_PROFILE_SCREEN: {
    name: 'view_profile_screen',
    description: 'User profile screen is displayed',
    trigger: 'On screen load',
    category: 'Screen View',
    feature: 'Profile',
    properties: ['entry_point'],
    importance: 'Medium',
    owner: 'Frontend Team'
  },
  CLICK_PROFILE_ICON: {
    name: 'click_profile_icon',
    description: 'User clicks the profile icon from Home',
    trigger: 'On profile icon tap',
    category: 'Click',
    feature: 'Global / Home',
    properties: ['entry_point'],
    importance: 'Medium',
    owner: 'Frontend Team'
  },
  VIEW_PROFILE_OPTIONS: {
    name: 'view_profile_options',
    description: 'Profile options list (My Profile/Join Community/TOS/Privacy/Refer) shown',
    trigger: 'On options load',
    category: 'Screen View',
    feature: 'Profile Options',
    properties: [],
    importance: 'Medium',
    owner: 'Frontend Team'
  },
  CLICK_MY_PROFILE_OPTION: {
    name: 'click_my_profile_option',
    description: 'User taps My Profile from options list',
    trigger: 'On option tap',
    category: 'Click',
    feature: 'Profile Options',
    properties: ['source_screen'],
    importance: 'Medium',
    owner: 'Frontend Team'
  },
  CLICK_JOIN_COMMUNITY_OPTION: {
    name: 'click_join_community_option',
    description: 'User taps Join Community from options list',
    trigger: 'On option tap',
    category: 'Click',
    feature: 'Profile Options',
    properties: ['source_screen'],
    importance: 'Medium',
    owner: 'Frontend Team'
  },
  CLICK_TERMS_OPTION: {
    name: 'click_terms_option',
    description: 'User taps Terms of Service',
    trigger: 'On option tap',
    category: 'Click',
    feature: 'Profile Options',
    properties: ['source_screen'],
    importance: 'Low',
    owner: 'Frontend Team'
  },
  CLICK_PRIVACY_OPTION: {
    name: 'click_privacy_option',
    description: 'User taps Privacy Policy',
    trigger: 'On option tap',
    category: 'Click',
    feature: 'Profile Options',
    properties: ['source_screen'],
    importance: 'Low',
    owner: 'Frontend Team'
  },
  CLICK_REFER_PARENT_OPTION: {
    name: 'click_refer_parent_option',
    description: 'User taps Refer a Parent',
    trigger: 'On option tap',
    category: 'Click',
    feature: 'Profile Options',
    properties: ['source_screen'],
    importance: 'Medium',
    owner: 'Frontend Team'
  },
  VIEW_MY_PROFILE: {
    name: 'view_my_profile',
    description: 'My Profile screen loads',
    trigger: 'On screen load',
    category: 'Screen View',
    feature: 'My Profile',
    properties: ['user_id'],
    importance: 'Medium',
    owner: 'Frontend Team'
  },
  UPDATE_FULL_NAME_INPUT: {
    name: 'update_full_name_input',
    description: 'User edits Full Name field',
    trigger: 'On input/change',
    category: 'Interaction',
    feature: 'My Profile',
    properties: ['new_name_length', 'input_method'],
    importance: 'Low',
    owner: 'Frontend Team'
  },
  UPDATE_GENDER_INPUT: {
    name: 'update_gender_input',
    description: 'User updates Gender',
    trigger: 'On select/change',
    category: 'Interaction',
    feature: 'My Profile',
    properties: ['gender_value'],
    importance: 'Low',
    owner: 'Frontend Team'
  },
  CLICK_SAVE_PROFILE_CHANGES: {
    name: 'click_save_profile_changes',
    description: 'User clicks Save on My Profile',
    trigger: 'On save/submit',
    category: 'Form Submit',
    feature: 'My Profile',
    properties: ['changed_fields'],
    importance: 'Medium',
    owner: 'Frontend Team'
  },
  PROFILE_SAVE_SUCCESS: {
    name: 'profile_save_success',
    description: 'Profile changes persisted successfully',
    trigger: 'On API success',
    category: 'Tech Event',
    feature: 'My Profile',
    properties: ['user_id', 'fields_saved'],
    importance: 'High',
    owner: 'Frontend Team'
  },
  PROFILE_SAVE_FAILED: {
    name: 'profile_save_failed',
    description: 'Saving profile changes failed',
    trigger: 'On API error',
    category: 'Tech Event',
    feature: 'My Profile',
    properties: ['error_code', 'error_message'],
    importance: 'High',
    owner: 'Frontend Team'
  },
  BACK_TO_PROFILE_OPTIONS: {
    name: 'back_to_profile_options',
    description: 'User navigates back to Profile Options list',
    trigger: 'On back',
    category: 'Navigation',
    feature: 'My Profile',
    properties: [],
    importance: 'Low',
    owner: 'Frontend Team'
  },
  BACK_FROM_TERMS: {
    name: 'back_from_terms',
    description: 'User navigates back from Terms to Profile Options',
    trigger: 'On back',
    category: 'Navigation',
    feature: 'Terms',
    properties: [],
    importance: 'Low',
    owner: 'Frontend Team'
  },
  BACK_FROM_PRIVACY: {
    name: 'back_from_privacy',
    description: 'User navigates back from Privacy to Profile Options',
    trigger: 'On back',
    category: 'Navigation',
    feature: 'Privacy',
    properties: [],
    importance: 'Low',
    owner: 'Frontend Team'
  },

  // Privacy Policy Events
  VIEW_PRIVACY_POLICY_SCREEN: {
    name: 'view_privacy_policy_screen',
    description: 'Privacy policy screen is displayed',
    trigger: 'On screen load',
    category: 'Screen View',
    feature: 'Legal',
    properties: ['entry_point'],
    importance: 'Low',
    owner: 'Frontend Team'
  },

  // Terms of Service Events
  VIEW_TERMS_OF_SERVICE_SCREEN: {
    name: 'view_terms_of_service_screen',
    description: 'Terms of service screen is displayed',
    trigger: 'On screen load',
    category: 'Screen View',
    feature: 'Legal',
    properties: ['entry_point'],
    importance: 'Low',
    owner: 'Frontend Team'
  },

  // Referral Events
  VIEW_REFERRAL_SCREEN: {
    name: 'view_referral_screen',
    description: 'Referral screen is displayed',
    trigger: 'On screen load',
    category: 'Screen View',
    feature: 'Referral',
    properties: ['entry_point'],
    importance: 'Medium',
    owner: 'Frontend Team'
  },
  VIEW_REFER_PARENT_SCREEN: {
    name: 'view_refer_parent_screen',
    description: 'Refer a Parent screen loads',
    trigger: 'On screen load',
    category: 'Screen View',
    feature: 'Refer Parent',
    properties: ['entry_point', 'referrer_event'],
    importance: 'Medium',
    owner: 'Frontend Team'
  },
  REFER_PARENT_OPEN_SHARE_SHEET: {
    name: 'refer_parent_open_share_sheet',
    description: 'User opens native share sheet to refer parent',
    trigger: 'On refer button click',
    category: 'Click/Tech',
    feature: 'Refer Parent',
    properties: ['invite_code', 'entry_point'],
    importance: 'High',
    owner: 'Frontend Team'
  },
  REFER_PARENT_SHARE_SENT: {
    name: 'refer_parent_share_sent',
    description: 'User successfully sends parent invite via native share',
    trigger: 'On share success callback',
    category: 'Tech Event',
    feature: 'Refer Parent',
    properties: ['invite_code', 'method', 'recipient_masked'],
    importance: 'High',
    owner: 'Frontend Team'
  },
  REFER_PARENT_SHARE_FAILED: {
    name: 'refer_parent_share_failed',
    description: 'Parent invite failed to send',
    trigger: 'On share error',
    category: 'Tech Event',
    feature: 'Refer Parent',
    properties: ['invite_code', 'error_code'],
    importance: 'Medium',
    owner: 'Frontend Team'
  },
  REFER_PARENT_CANCELLED: {
    name: 'refer_parent_cancelled',
    description: 'User cancels refer/share action before sending',
    trigger: 'On cancel',
    category: 'Interaction',
    feature: 'Refer Parent',
    properties: ['invite_code'],
    importance: 'Medium',
    owner: 'Frontend Team'
  },

  // Review Login Events
  VIEW_REVIEW_LOGIN_SCREEN: {
    name: 'view_review_login_screen',
    description: 'Review login screen is displayed',
    trigger: 'On screen load',
    category: 'Screen View',
    feature: 'Authentication',
    properties: ['entry_point'],
    importance: 'Medium',
    owner: 'Frontend Team'
  },

  // Cry Analyser Events
  VIEW_CRY_ANALYSER_SCREEN: {
    name: 'view_cry_analyser_screen',
    description: 'Cry Analyser screen is displayed',
    trigger: 'On screen load',
    category: 'Screen View',
    feature: 'Cry Analyser',
    properties: [],
    importance: 'High',
    owner: 'Frontend Team'
  },
  CLICK_RECORD_AUDIO: {
    name: 'click_record_audio',
    description: 'User clicks record button to start recording',
    trigger: 'On record button click',
    category: 'Click',
    feature: 'Cry Analyser',
    properties: [],
    importance: 'High',
    owner: 'Frontend Team'
  },
  RECORDING_STARTED: {
    name: 'recording_started',
    description: 'Audio recording begins',
    trigger: 'On record start',
    category: 'Tech Event',
    feature: 'Cry Analyser',
    properties: ['duration_limit'],
    importance: 'Medium',
    owner: 'Frontend Team'
  },
  RECORDING_STOPPED_AUTO: {
    name: 'recording_stopped_auto',
    description: 'Recording ends automatically after 5 seconds',
    trigger: 'On record timeout',
    category: 'Tech Event',
    feature: 'Cry Analyser',
    properties: ['trigger', 'duration'],
    importance: 'Medium',
    owner: 'Frontend Team'
  },
  CLICK_UPLOAD_AUDIO: {
    name: 'click_upload_audio',
    description: 'User selects to upload audio file',
    trigger: 'On upload button click',
    category: 'Click',
    feature: 'Cry Analyser',
    properties: [],
    importance: 'Medium',
    owner: 'Frontend Team'
  },
  UPLOAD_FILE_SELECTED: {
    name: 'upload_file_selected',
    description: 'User selects file to upload',
    trigger: 'On file selection',
    category: 'Feature Event',
    feature: 'Cry Analyser',
    properties: ['file_type', 'file_size_kb'],
    importance: 'Medium',
    owner: 'Frontend Team'
  },
  UPLOAD_AUDIO_STARTED: {
    name: 'upload_audio_started',
    description: 'Audio file upload to S3 begins',
    trigger: 'On upload start',
    category: 'Tech Event',
    feature: 'Cry Analyser',
    properties: ['method', 'source'],
    importance: 'Medium',
    owner: 'Backend Team'
  },
  UPLOAD_AUDIO_SUCCESS: {
    name: 'upload_audio_success',
    description: 'Audio successfully uploaded to S3',
    trigger: 'On upload complete',
    category: 'Tech Event',
    feature: 'Cry Analyser',
    properties: ['s3_url', 'upload_duration_ms'],
    importance: 'High',
    owner: 'Backend Team'
  },
  CRY_ANALYSIS_REQUESTED: {
    name: 'cry_analysis_requested',
    description: 'Model API is triggered with uploaded S3 link',
    trigger: 'On API request start',
    category: 'Tech Event',
    feature: 'Cry Analyser',
    properties: ['s3_url', 'user_id'],
    importance: 'High',
    owner: 'Backend Team'
  },
  CRY_ANALYSIS_RESPONSE_RECEIVED: {
    name: 'cry_analysis_response_received',
    description: 'Cry analysis model returns response',
    trigger: 'On API response',
    category: 'Tech Event',
    feature: 'Cry Analyser',
    properties: ['status', 'latency_ms'],
    importance: 'High',
    owner: 'Backend Team'
  },

  // Cry Report Events
  VIEW_CRY_REPORT_SCREEN: {
    name: 'view_cry_report_screen',
    description: 'Cry Analyser report screen is shown',
    trigger: 'On screen load',
    category: 'Screen View',
    feature: 'Cry Report',
    properties: ['recommendation_count'],
    importance: 'High',
    owner: 'Frontend Team'
  },
  SCROLL_RECOMMENDATION_CARDS: {
    name: 'scroll_recommendation_cards',
    description: 'User scrolls between recommendation cards',
    trigger: 'On scroll interaction',
    category: 'Scroll',
    feature: 'Cry Report',
    properties: ['cards_viewed_count'],
    importance: 'Low',
    owner: 'Frontend Team'
  },
  FEEDBACK_UPVOTE: {
    name: 'feedback_upvote',
    description: 'User upvotes a recommendation card',
    trigger: 'On upvote button click',
    category: 'Click',
    feature: 'Cry Report',
    properties: ['card_id', 'feedback_type'],
    importance: 'Medium',
    owner: 'Frontend Team'
  },
  FEEDBACK_DOWNVOTE: {
    name: 'feedback_downvote',
    description: 'User downvotes a recommendation card',
    trigger: 'On downvote button click',
    category: 'Click',
    feature: 'Cry Report',
    properties: ['card_id', 'feedback_type'],
    importance: 'Medium',
    owner: 'Frontend Team'
  },
  CLICK_SHARE_REPORT: {
    name: 'click_share_report',
    description: 'User clicks share icon to generate shareable report link',
    trigger: 'On share icon click',
    category: 'Click',
    feature: 'Cry Report',
    properties: ['share_type', 'report_id'],
    importance: 'Medium',
    owner: 'Frontend Team'
  },
  CLICK_DOWNLOAD_REPORT: {
    name: 'click_download_report',
    description: 'User clicks to download PDF report',
    trigger: 'On download icon click',
    category: 'Click',
    feature: 'Cry Report',
    properties: ['file_type', 'report_id'],
    importance: 'Medium',
    owner: 'Frontend Team'
  },
  DOWNLOAD_STARTED: {
    name: 'download_started',
    description: 'PDF download of the report begins',
    trigger: 'On download start',
    category: 'Tech Event',
    feature: 'Cry Report',
    properties: ['file_size_kb', 'report_id'],
    importance: 'Medium',
    owner: 'Frontend Team'
  },

  // Error Events
  NON_CRY_DETECTED: {
    name: 'non_cry_detected',
    description: 'Model analysis identified the audio as non-cry',
    trigger: 'On model API response',
    category: 'Tech Event',
    feature: 'Cry Analyser',
    properties: ['reason', 'confidence_score', 'audio_id'],
    importance: 'Medium',
    owner: 'Backend Team'
  },
  ANALYSIS_API_FAILED: {
    name: 'analysis_api_failed',
    description: 'Model API call failed due to server or network error',
    trigger: 'On API error',
    category: 'Tech Event',
    feature: 'Cry Analyser',
    properties: ['error_type', 'error_message', 'audio_id'],
    importance: 'High',
    owner: 'Backend Team'
  },
  VIEW_ERROR_SCREEN: {
    name: 'view_error_screen',
    description: 'User sees the error screen (shared for non-cry or API fail)',
    trigger: 'On error UI render',
    category: 'Screen View',
    feature: 'Cry Analyser',
    properties: ['error_type', 'message_shown'],
    importance: 'Medium',
    owner: 'Frontend Team'
  },
  CLICK_CANCEL_ERROR_SCREEN: {
    name: 'click_cancel_error_screen',
    description: 'User clicks "Cancel" on error screen',
    trigger: 'On button click',
    category: 'Click',
    feature: 'Cry Analyser',
    properties: ['error_type', 'return_to'],
    importance: 'Medium',
    owner: 'Frontend Team'
  },
  CLICK_RERECORD_ERROR_SCREEN: {
    name: 'click_rerecord_error_screen',
    description: 'User clicks "Rerecord" on error screen',
    trigger: 'On button click',
    category: 'Click',
    feature: 'Cry Analyser',
    properties: ['error_type', 'return_to'],
    importance: 'Medium',
    owner: 'Frontend Team'
  },
  subscription_popup_shown: {
    name: 'subscription_popup_shown',
    description: 'Subscription popup is displayed to the user',
    trigger: 'When popup opens',
    category: 'Screen View',
    feature: 'Subscription',
    properties: ['popup_type', 'has_plan_selected', 'plan_count', 'is_subscribed'],
    importance: 'High',
    owner: 'Frontend Team'
  },
  subscription_popup_subscribe_clicked: {
    name: 'subscription_popup_subscribe_clicked',
    description: 'User clicks subscribe button in popup',
    trigger: 'On subscribe button click',
    category: 'Click',
    feature: 'Subscription',
    properties: ['plan_text', 'plan_final_amount', 'plan_discount', 'is_subscribed'],
    importance: 'High',
    owner: 'Frontend Team'
  },
  subscription_popup_closed: {
    name: 'subscription_popup_closed',
    description: 'User manually closes the subscription popup',
    trigger: 'On popup close',
    category: 'Interaction',
    feature: 'Subscription',
    properties: ['had_plan_selected', 'is_subscribed', 'close_reason'],
    importance: 'Medium',
    owner: 'Frontend Team'
  },
  subscription_popup_completed: {
    name: 'subscription_popup_completed',
    description: 'Subscription popup closes after successful payment',
    trigger: 'After successful subscription',
    category: 'Conversion',
    feature: 'Subscription',
    properties: ['had_plan_selected', 'is_subscribed', 'close_reason'],
    importance: 'Critical',
    owner: 'Frontend Team'
  },
  click_subscription_button: {
    name: 'click_subscription_button',
    description: 'User clicks the subscription button on homepage',
    trigger: 'On button click',
    category: 'Click',
    feature: 'Subscription',
    properties: ['entry_point', 'user_status', 'subscription_status'],
    importance: 'High',
    owner: 'Frontend Team'
  },
  subscription_button_subscribe_clicked: {
    name: 'subscription_button_subscribe_clicked',
    description: 'User clicks the subscribe button on subscription page',
    trigger: 'On subscribe button click',
    category: 'Click',
    feature: 'Subscription',
    properties: ['plan_text', 'plan_final_amount', 'plan_discount', 'subscription_status'],
    importance: 'High',
    owner: 'Frontend Team'
  },
  subscription_button_subscribe_completed: {
    name: 'subscription_button_subscribe_completed',
    description: 'User successfully completes subscription and sees success modal',
    trigger: 'When success modal is displayed',
    category: 'Conversion',
    feature: 'Subscription',
    properties: ['payment_method', 'subscription_active'],
    importance: 'Critical',
    owner: 'Frontend Team'
  },
  
  // App Update Events
  CLICK_UPDATE_APP: {
    name: 'click_update_app',
    description: 'User clicks the update app button on update required screen',
    trigger: 'On update button click',
    category: 'Click',
    feature: 'App Update',
    properties: ['source', 'redirect_url'],
    importance: 'High',
    owner: 'Frontend Team'
  }
};

// Funnels Configuration
export const FUNNELS = {
  AUTHENTICATION: {
    name: 'Authentication Funnel',
    steps: [
      'view_auth_screen',
      'submit_phone_number',
      'view_otp_screen',
      'submit_otp_code',
      'otp_verification_success'
    ]
  },
  ONBOARDING: {
    name: 'Onboarding Funnel',
    steps: [
      'view_welcome_screen',
      'view_tutorial_cry_analyser',
      'view_tutorial_meet_qara',
      'view_tutorial_expert_care',
      'click_get_started'
    ]
  },
  CRY_ANALYSIS: {
    name: 'Cry Analysis Funnel',
    steps: [
      'view_cry_analyser_screen',
      'click_record_audio',
      'recording_started',
      'cry_analysis_requested',
      'cry_analysis_response_received',
      'view_cry_report_screen'
    ]
  }
};

// Event Categories
export const EVENT_CATEGORIES = {
  SCREEN_VIEW: 'Screen View',
  FORM_SUBMIT: 'Form Submit',
  CLICK: 'Click',
  TECH_EVENT: 'Tech Event',
  NAVIGATION: 'Navigation',
  FEATURE_EVENT: 'Feature Event',
  SCROLL: 'Scroll'
};

// Features
export const FEATURES = {
  AUTHENTICATION: 'Authentication',
  PHONE_AUTH: 'Phone Auth',
  GOOGLE_AUTH: 'Google Auth',
  PROFILE_SETUP: 'Profile Setup',
  ONBOARDING: 'Onboarding',
  ONBOARDING_TUTORIAL: 'Onboarding Tutorial',
  HOME: 'Home',
  CRY_ANALYSER: 'Cry Analyser',
  CRY_REPORT: 'Cry Report',
  QARA: 'QARA',
  EXPERTS: 'Experts',
  FOR_YOU: 'For You',
  ASSESSMENT: 'Assessment',
  PROFILE: 'Profile',
  LEGAL: 'Legal',
  REFERRAL: 'Referral',
  APP_UPDATE: 'App Update'
};
